// app/javascript/controllers/wiki_sidebar_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["sidebar", "toggleIcon"]
    static values = {
        storageKey: { type: String, default: "wiki_sidebar_collapsed" }
    }

    connect() {
        this.initializeState()
        this.handleResize = this.handleResize.bind(this)
        window.addEventListener('resize', this.handleResize)
    }

    disconnect() {
        window.removeEventListener('resize', this.handleResize)
    }

    initializeState() {
        const isCollapsed = this.getStoredState()
        if (isCollapsed) {
            this.collapse()
        } else {
            this.expand()
        }
    }

    toggle() {
        if (this.isCollapsed()) {
            this.expand()
        } else {
            this.collapse()
        }
    }

    collapse() {
        this.sidebarTarget.classList.add('-translate-x-full', 'lg:-translate-x-0', 'lg:w-0', 'lg:opacity-0', 'lg:overflow-hidden')
        this.sidebarTarget.classList.remove('translate-x-0', 'lg:w-80', 'lg:opacity-100')
        if (this.hasToggleIconTarget) {
            this.toggleIconTarget.classList.remove('rotate-180')
        }
        this.storeState(true)
    }

    expand() {
        this.sidebarTarget.classList.remove('-translate-x-full', 'lg:-translate-x-0', 'lg:w-0', 'lg:opacity-0', 'lg:overflow-hidden')
        this.sidebarTarget.classList.add('translate-x-0', 'lg:w-80', 'lg:opacity-100')
        if (this.hasToggleIconTarget) {
            this.toggleIconTarget.classList.add('rotate-180')
        }
        this.storeState(false)
    }

    isCollapsed() {
        return this.sidebarTarget.classList.contains('lg:w-0')
    }

    handleResize() {
        // On mobile, sidebar is overlay; on desktop, it's inline
        const isMobile = window.innerWidth < 1024
        if (isMobile && !this.isCollapsed()) {
            // Add backdrop on mobile when expanded
            this.showBackdrop()
        } else {
            this.hideBackdrop()
        }
    }

    showBackdrop() {
        if (!this.backdrop) {
            this.backdrop = document.createElement('div')
            this.backdrop.className = 'fixed inset-0 bg-black/50 z-30 lg:hidden'
            this.backdrop.addEventListener('click', () => this.collapse())
            this.element.appendChild(this.backdrop)
        }
    }

    hideBackdrop() {
        if (this.backdrop) {
            this.backdrop.remove()
            this.backdrop = null
        }
    }

    getStoredState() {
        return localStorage.getItem(this.storageKeyValue) === 'true'
    }

    storeState(isCollapsed) {
        localStorage.setItem(this.storageKeyValue, isCollapsed)
    }
}
